import { Link } from "react-router-dom";
import { useGetSiteBlogQuery } from "../../../Redux/Apis/blogApi";

function RecentPost({site_id}) {
    const {data:blogs, isLoading: isAllLoading} = useGetSiteBlogQuery(site_id)

    return ( 
        <div className="recent-posts">
            <h4>آخرین پست ها</h4>
            <ul>{
                isAllLoading ? 'در حال لود' :
                blogs && blogs.map((row,index) => 
                    <li key={index}><Link to={`/post/${row.id}`}>{row.title}</Link></li>
                )}
            </ul>
        </div>
    );
}

export default RecentPost;